export default __webpack_public_path__ + "static/media/qr.8e3a87fb.svg";